<div style="margin:20px;">
  <div id="titulo">
    <h2>Buscar peticiones {{this.controlGestion}}</h2>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
  </div>
  <h3>Datos de cliente</h3>
  <div style="display: flex;gap: 10px;margin-top:20px; width:100%;">
    <div class="campo">
      <label>Fecha Inicio</label>
      <input matInput [matDatepicker]="fInicio" (click)="fInicio.open()" [(ngModel)]="this.fechaInicio" >
      <mat-datepicker #fInicio></mat-datepicker>
    </div>
    <div class="campo">
      <label>Fecha Fin</label>
      <input matInput [matDatepicker]="fFin" (click)="fFin.open()" [(ngModel)]="this.fechaFin" >
      <mat-datepicker #fFin></mat-datepicker>
    </div>
    <div class="campo">
      <label>Estado</label>
      <mat-select style="display:block;min-width: 0;width: 100%;" [(ngModel)]="this.estado">
        <mat-option value="0">0-Pendientes</mat-option>
        <mat-option value="1">1-Gestionadas</mat-option>
        <mat-option value="2">2-Rellamadas</mat-option>
        <mat-option value="9">9-Todas</mat-option>
      </mat-select>
    </div>
    <div *ngIf="this.controlGestion=='gestionWebNew' || this.controlGestion=='rauda'" class="campo">
      <label>Código cita</label>
      <input matInput [(ngModel)]="this.codigoCita" >
    </div>
    <div *ngIf="this.controlGestion!='gestionWeb' && this.controlGestion!='outbound'" class="campo">
      <label>Matrícula</label>
      <input matInput [(ngModel)]="this.matricula">
    </div>
    <div *ngIf="this.controlGestion=='gestionWebNew' || this.controlGestion=='rauda'" class="campo">
      <label>Teléfono</label>
      <input matInput [(ngModel)]="this.telefono" type="tel" maxlength="9">
    </div>
    <div *ngIf="this.controlGestion=='gestionWebNew' || this.controlGestion=='gestionWeb'" class="campo">
      <label>Tipo de gestión</label>
      <mat-select style="display:block;min-width: 0;width: 100%;" [(ngModel)]="this.tipoGestion" (ngModelChange)="limpiarTabla()">
        <mat-option *ngFor="let opt of this.tipoGestiones" [value]="opt.codigo">{{opt.codigo +" "+opt.nombre}}</mat-option>
      </mat-select>
    </div>
    <div *ngIf="this.controlGestion=='gestionWebNew'" class="campo">
      <label>RESPUESTA IA</label>
      <mat-select style="display:block;min-width: 0;width: 100%;" [(ngModel)]="this.respuestaIa">
        <mat-option value="">TODOS</mat-option>
        <mat-option value="S">RESPUESTA IA</mat-option>
        <mat-option value="N">NO TIENE RESPUESTA</mat-option>
      </mat-select>
    </div>
    <div class="campo" >
      <label></label>
      <a class="btnCCOscuro" mat-flat-button style="width:100%;max-height:50%;padding:0" (click)="buscar()" >Buscar</a>
    </div>
    <div *ngIf="this.dataSource.data.length>0" class="campo" >
      <label></label>
      <a class="btnCCOscuro" mat-flat-button style="width:100%;max-height:50%;padding:0" (click)="exportarResultados()" >Exportar</a>
    </div>
  </div>
  <mat-dialog-content style="display:flex;justify-content:center;width:100%;height:440px; padding: 0px; padding-top: 10px;">
    <!--tabla con el listado de peticiones encontradas-->
    <div id="tablaContainer">
      <table mat-table class="tabla-art" [dataSource]="dataSource" matSort>
        <div [ngSwitch]="controlGestion">
          <div *ngSwitchCase="'gestionWebNew'">
            <ng-container *ngFor="let column of columnasNew" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>              
              <ng-container *ngIf="column=='tipo'">
                <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{traducirTipoGestion(element[column])}}</td>
              </ng-container>
              <ng-container *ngIf="column=='estado' || column=='estadoContact'">
                <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{traducirEstado(element[column],element['tipo'],element)}}</td>
              </ng-container>
              <!-- <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th> -->
              <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{element[column]}}</td>
            </ng-container>
          </div>
          <div *ngSwitchCase="'outbound'">
            <ng-container *ngFor="let column of columnasOutbound" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
              <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{element[column]}}</td>
            </ng-container>
          </div>
          <div *ngSwitchCase="'gestionWeb'">
            <ng-container *ngFor="let column of columnasGestionWeb" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
              <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{element[column]}}</td>
            </ng-container>
          </div>
          <div *ngSwitchCase="'rauda'">
            <ng-container *ngFor="let column of columnasRauda" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
              <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{element[column]}}</td>
            </ng-container>
          </div>
          <div *ngSwitchCase="'segurCaixa'">
            <ng-container *ngFor="let column of columnasSegurCaixa" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
              <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{element[column]}}</td>
            </ng-container>
          </div>
          <div *ngSwitchCase="'lineaDirecta'">
            <ng-container *ngFor="let column of columnasLineaDirecta" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
              <td mat-cell *matCellDef="let element" (dblclick)="cargarHoja(element)">{{element[column]}}</td>
            </ng-container>
          </div>
          <div *ngSwitchCase="'caser'">
            <ng-container *ngFor="let column of columnasCaser" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
              <td mat-cell *matCellDef="let element" (dblclick)="cargarDetalle(element)">{{element[column]}}</td>
            </ng-container>
          </div>
        </div>
        <!-- Columna de gestion -->
         
        <ng-container matColumnDef="gestion">
          <th mat-header-cell *matHeaderCellDef style="background: white;">Gestión</th>
          <td mat-cell *matCellDef="let element" style="background-color: white !important;">
            <!--<a style="max-height: 100%;" class="btnCCOscuro" mat-flat-button (click)="cargarDetalle(element)">Gestionar</a>-->
            <a style="max-height: 100%;" class="btnCCOscuro" (click)="cambiarEstado(element)" mat-flat-button >Gestionar</a>
          </td>
        </ng-container>

        <div [ngSwitch]="controlGestion">
          <div *ngSwitchCase="'gestionWebNew'">
            <tr mat-header-row *matHeaderRowDef="columnasNew.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasNew.concat('gestion');"></tr>
          </div>
          <div *ngSwitchCase="'outbound'">
            <tr mat-header-row *matHeaderRowDef="columnasOutbound.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasOutbound.concat('gestion');"></tr>
          </div>
          <div *ngSwitchCase="'gestionWeb'">
            <tr mat-header-row *matHeaderRowDef="columnasGestionWeb.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasGestionWeb.concat('gestion');"></tr>
          </div>
          <div *ngSwitchCase="'segurCaixa'">
            <tr mat-header-row *matHeaderRowDef="columnasSegurCaixa.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasSegurCaixa.concat('gestion');"></tr>
          </div>
          <div *ngSwitchCase="'lineaDirecta'">
            <tr mat-header-row *matHeaderRowDef="columnasLineaDirecta.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasLineaDirecta.concat('gestion');"></tr>
          </div>
          <div *ngSwitchCase="'caser'">
            <tr mat-header-row *matHeaderRowDef="columnasCaser.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasCaser.concat('gestion');"></tr>
          </div>
          <div *ngSwitchCase="'rauda'">
            <tr mat-header-row *matHeaderRowDef="columnasRauda.concat('gestion')"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasRauda.concat('gestion');"></tr>
          </div>
        </div>
      </table>
    </div>
  </mat-dialog-content>
  <mat-progress-bar *ngIf="mostrarCarga" mode="indeterminate"></mat-progress-bar>
  <mat-paginator class="paginador" [pageSizeOptions]="[10, 25, 100]" [length]="dataSource.data.length" [pageSize]="10" [showFirstLastButtons]="true" #paginator (page)="onPageChange($event)"></mat-paginator>
</div>

